module.exports = __webpack_public_path__ + "static/media/closeFullscreenW.6702b074.png";